import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { isStringEmptyOrNull } from "./StringUtility";

@Injectable({ providedIn: 'root' })
export class DataUtility {

  constructor(private snackbar: MatSnackBar) { }

  getCheckReason(guest: any, reasonKey: string) {
    if (!guest) {
      return 'Not Found';
    }

    let reasonInfo = guest[0].details.find((guest: any) => guest.key === reasonKey);
    return reasonInfo.value;
  }

  getTrustInfo(guest:any, trustKey: string) {
    if (!guest) {
      return 'Not Found';
    }

    let trustInfo = guest[0].details.find((guest: any) => guest.key === trustKey);
    return this.getTextFromValue(trustInfo.value);
  }

  displaySnackbar(errorMessage: string) {
    if (isStringEmptyOrNull(errorMessage)) {
      this.displaySuccessSnackbar();
    } else {
      this.displayErrorSnackbar(errorMessage);
    }
  }

  displaySuccessSnackbar() {
    this.snackbar.open('Save Successful', 'OK', { duration: 4000 });
  }
  
  displayErrorSnackbar(errorMessage: string) {
    this.snackbar.open(`Error Saving Organization: ${errorMessage}`, 'OK', { duration: 4000 });
  }

  getColor(result?: any) {
    switch (result) {
      case 'Y': 
        return 'green';
      case 'Approve': 
        return 'green';
      case 'N': 
        return 'red';
      case 'Deny': 
        return 'red';
      default: 
        return 'white';
    }
  }

  getDecisionColor(result?: any) {
    switch (result) {
      case 'Y': 
        return 'background-green';
      case 'Approve': 
        return 'background-green';
      case 'N': 
        return 'background-red';
      case 'Deny': 
        return 'background-red';
      default: 
        return 'white';
    }
  }

  getTextFromValue(value: any) {
    switch (value) {
      case 'Y': 
        return 'Approve';
      case 'N': 
        return 'Deny';
      default: 
        return 'Considering';
    }
  }

}

export const getServiceNameFromServiceId = (serviceId: number): string => {
  switch (serviceId) {
    case 0:
      return 'Guest Verification and Insurance Protection';
    case 1:
      return 'Guest Verification Only';
    case 2:
      return 'Insurance Protection Only';
    default:
      return '';
  }
}